module.exports = __webpack_public_path__ + "img/WFH-AGS-2025-Logo-FR.0a1d2c40.png";